const notificationAction = 'NotificationCenter';

/** Notification Fetch Actions */
export const FETCH_NOTIFICATIONS_ERROR = `${notificationAction}/FETCH_NOTIFICATIONS_ERROR`;
export const FETCH_NOTIFICATIONS_REQUEST = `${notificationAction}/FETCH_NOTIFICATIONS_REQUEST`;
export const FETCH_NOTIFICATIONS_RESPONSE = `${notificationAction}/FETCH_NOTIFICATIONS_RESPONSE`;

export const FETCH_NOTIFICATION_COUNT_ERROR = `${notificationAction}/FETCH_NOTIFICATION_COUNT_ERROR`;
export const FETCH_NOTIFICATION_COUNT_REQUEST = `${notificationAction}/FETCH_NOTIFICATION_COUNT_REQUEST`;
export const FETCH_NOTIFICATION_COUNT_RESPONSE = `${notificationAction}/FETCH_NOTIFICATION_COUNT_RESPONSE`;

export const UPDATE_NOTIFICATIONS_ERROR = `${notificationAction}/UPDATE_NOTIFICATIONS_ERROR`;
export const UPDATE_NOTIFICATIONS_REQUEST = `${notificationAction}/UPDATE_NOTIFICATIONS_REQUEST`;
export const UPDATE_NOTIFICATIONS_RESPONSE = `${notificationAction}/UPDATE_NOTIFICATIONS_RESPONSE`;

export const UPDATE_NOTIFICATION_CENTER_FILTERS = `${notificationAction}/UPDATE_NOTIFICATION_CENTER_FILTERS`;
